import React from "react";
import PropTypes from "prop-types";
import { UiButton } from "ui-components";

/**
 * اکشن ویرایش
 * @param {*Object} action آبجکت اکشن
 * @param {*Number} itemId شناسه رکورد
 */
const UiActionEdit = ({ action }) => {
    return (
        <UiButton
            type="icon"
            className={`icon ${action.icon}`}
            size="xxs"
            tooltip={action.tooltip}
            disabled={action.disabled}
            href={action.href}
        />
    );
};
UiActionEdit.propTypes = {
    action: PropTypes.object,
    itemId: PropTypes.any,
};

export default UiActionEdit;
